import { LogIn } from "lucide-react";
import { useEffect, useState } from "react";
import { getAccountCopy } from "../../data/accountCopy";
import { useTranslation } from "../../i18n";

import { ButtonLink } from "../ui";

export function SignedOutPanel() {
	const { locale, localizedPath } = useTranslation();
	const { signedOut: copy, myPage } = getAccountCopy(locale);
	const [showDevLogin, setShowDevLogin] = useState(false);
	useEffect(() => {
		setShowDevLogin(window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
	}, []);
	return (
		<section className="mx-auto max-w-xl">
			<div className="py-4 sm:py-8 lg:py-12">
				<p className="mb-6 flex items-center gap-3 text-xs font-medium tracking-widest text-muted-foreground">
					<span className="h-px w-8 bg-primary" aria-hidden="true" />
					{myPage.title}
				</p>
				<h1
					aria-label={copy.title}
					className="text-2xl font-semibold leading-relaxed tracking-tight text-foreground sm:text-4xl"
				>
					{copy.titleLines.map(line => (
						<span key={line} className="block">
							{line}
						</span>
					))}
				</h1>
				<p className="mt-5 max-w-sm text-sm leading-7 text-muted-foreground sm:text-base">{copy.description}</p>
				<div className="mt-8 flex flex-col items-start gap-3">
					<ButtonLink href="/share/auth/google" size="lg" className="w-full justify-between gap-8 sm:w-auto">
						<span className="flex items-center gap-3">
							<LogIn size={18} />
							{copy.googleLogin}
						</span>
					</ButtonLink>
					{showDevLogin && (
						<ButtonLink href="/share/auth/dev-login" variant="ghost" size="sm">
							{copy.devLogin}
						</ButtonLink>
					)}
				</div>
				<p className="mt-8 max-w-sm border-t border-border pt-4 text-xs leading-6 text-muted-foreground">
					{copy.accountHint}
				</p>
				<ButtonLink href={localizedPath("/")} variant="ghost" className="mt-4">
					{copy.continueWithoutLogin}
				</ButtonLink>
			</div>
		</section>
	);
}
